import { useState, useEffect, Fragment } from 'react'

import { slugify, SIZES, fileNameAndExt } from '../../helpers/helpers'

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/'

const PRODUCT_FILES_URL =
    'https://cdn.shopify.com/s/files/1/2338/2917/products/'

const DEFAULT_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/default-image.png?v=1628278950'

const DEFAULT_SWATCH_IMAGE_SRC =
    'https://cdn.shopify.com/s/files/1/2338/2917/files/maswatch-default-96.png'

const Product = ({ product }) => {
    // console.log('product in product', product)

    let variants = product.variants

    variants = variants.filter((v) => {
        return v.inventory_quantity > 0
    })

    // console.log('variants', variants)

    // console.log('variants, product in Product', variants, product)

    const v = variants[0]

    let imageSrc
    let imageAlt

    if (product && product.images_info && product.images_info[0]) {
        imageSrc = product.images_info[0].src
        imageAlt = product.images_info[0].alt ? product.images_info[0].alt : 'product image'
    }



    let smallImageSource = ''

    let imageSrcArray

    if (imageSrc) {
        imageSrcArray = fileNameAndExt(imageSrc)
        console.log('imageSrc, imageSrcArray', imageSrc, imageSrcArray)
        smallImageSource =
            imageSrcArray[0] + "/" + imageSrcArray[1] + "_400x400." +
            imageSrcArray[2]
        // console.log('smallImageSource', smallImageSource)
    } else {
        imageSrc = DEFAULT_IMAGE_SRC
    }

    const [sizes, setSizes] = useState('')
    const [currentPattern, setCurrentPattern] = useState('')
    const [currentImage, setCurrentImage] = useState({
        src: smallImageSource ? smallImageSource : imageSrc,
        alt: imageAlt,
    })
    const [value, setValue] = useState('Size')
    const [currentVariantId, setCurrentVariantId] = useState(
        v && v.id ? v.id : null
    )

    const patternList = variants
        .filter((p) => {
            return p.product_id === v.product_id
        })
        .map((v) => {
            return v.initial_color
        })

    const patterns = [...new Set(patternList)]

    // console.log('patterns', patterns)

    let matchingVariants = variants.filter((m) => {
        return (
            m.product_id === v.product_id && m.initial_color === v.initial_color
        )
    })

    // console.log('matchingVariants', matchingVariants)

    useEffect(() => {
        let sizeList = matchingVariants.map((m) => {
            if (m.initial_size) {
                return {
                    id: m.id,
                    size: m.initial_size,
                    quantity: m.inventory_quantity,
                }
            }
            return null
        })

        // console.log('sizeList', sizeList)

        let filteredSizes = sizeList.filter(function (el) {
            return el != null
        })

        let sortedSizeList

        if (filteredSizes && filteredSizes.length > 0) {
            sortedSizeList = filteredSizes.sort(sortFunc)
        }

        if (sortedSizeList) {
            setSizes(sortedSizeList)
        } else {
            setSizes(false)
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (v) {
            let initialPattern = v.initial_color
            setCurrentPattern(initialPattern)
        }
    }, [v])

    // console.log('sortedSizeList', sortedSizeList)

    const firstVariant = matchingVariants.find(function (el) {
        return el.inventory_quantity >= 0
    })

    // let currentUrl = window.location.href
    // let currentBaseUrl = window.location.href.split('?')[0]
    let currentBaseUrl = window.location.origin

    const handleSwatchClick = (productId, pattern) => {
        setCurrentPattern(pattern)

        // update list of matches
        matchingVariants = variants.filter((m) => {
            if (m.product_id === productId) {
                console.log(
                    'm, m.initial_color, pattern',
                    m,
                    m.initial_color,
                    pattern
                )
            }

            return m.product_id === productId && m.initial_color === pattern
        })

        console.log('matchingVariants after swatch click', matchingVariants)

        // extract sizes from new matches
        let sizeList = matchingVariants.map((m) => {
            return {
                id: m.id,
                size: m.initial_size,
                quantity: m.inventory_quantity,
            }
        })

        // console.log('sizeList', sizeList)

        let sortedSizeList = sizeList.sort(sortFunc)

        if (sortedSizeList) {
            setSizes(sortedSizeList)
        }

        const firstMatchWithInventory = matchingVariants.find(function (el) {
            if (el.inventory_quantity > 0) {
                return el.inventory_quantity > 0
            } else {
                return matchingVariants[0]
            }
        })

        console.log('firstMatchWithInventory', firstMatchWithInventory)

        if (firstMatchWithInventory) {
            setCurrentImage({
                src: firstMatchWithInventory.image,
                alt: imageAlt,
            })
        }

        if (value === 'Size' || value === 'undefined' || value === null) {
            console.log('value after swatch click', value)
            // console.log('swatch selected one size', firstMatchWithInventory.id)

            setCurrentVariantId(firstMatchWithInventory.id)
        } else {
            // get variant ID for new pattern variant in selected size
            let selectedSizeVariant = matchingVariants.filter((m) => {
                return m.initial_size === value
            })
            // console.log(
            //     'selectedSizeVariant',
            //     selectedSizeVariant,
            //     selectedSizeVariant[0].id
            // )
            setCurrentVariantId(selectedSizeVariant[0].id)
        }
    }

    const handleSizeSelect = (e) => {
        // console.log('e.target Size', e.target)
        let variantId =
            e.target[e.target.selectedIndex].getAttribute('data-variant-id')
        // console.log('variantId on size select', variantId)
        setValue(e.target.value)
        setCurrentVariantId(variantId)
    }

    function sortFunc(a, b) {
        let sortingArr = SIZES
        return sortingArr.indexOf(a.size) - sortingArr.indexOf(b.size)
    }

    // if (product.id === '6747100839998' || product.id === 6747100839998) {
    //     console.log('sizes', sizes)
    // }

    return (
        <Fragment>
            {firstVariant && firstVariant ? (
                <li className="product" key={firstVariant.id}>
                    <div className="height">
                        <div className="product-outer">
                            <div
                                className="product-image"
                                data-color={firstVariant.initial_color}
                            >
                                <a
                                    href={`${currentBaseUrl}/products/${
                                        product.handle
                                    }${
                                        currentVariantId
                                            ? '?variant=' + currentVariantId
                                            : null
                                    }`}
                                >
                                    <img
                                        src={
                                            currentImage
                                                ? currentImage.src
                                                : null
                                        }
                                        alt={
                                            imageAlt
                                                ? imageAlt
                                                : product.handle +
                                                  ' ' +
                                                  firstVariant.title
                                        }
                                        onError={(e) => {
                                            if (
                                                e.target.src !==
                                                DEFAULT_IMAGE_SRC
                                            ) {
                                                e.target.onerror = null
                                                e.target.src = DEFAULT_IMAGE_SRC
                                            }
                                        }}
                                    />
                                </a>
                            </div>

                            <div className="product-inner">
                                <div className="product-top">
                                    <h3 className="product-title">
                                        {product.title.replace('_', ' - ')}
                                    </h3>
                                    <div
                                        data-bv-show="rating_summary"
                                        data-bv-product-id={
                                            product ? product.id
                                                : null
                                        }
                                    ></div>
                                    <p className="product-price">
                                        ${firstVariant.price}
                                    </p>
                                    <p className="product-available">
                                        Available in {patterns.length}{' '}
                                        {patterns.length === 1
                                            ? 'color'
                                            : 'colors'}
                                    </p>
                                </div>
                                <div className="product-bottom">
                                    <div className="product-swatches">
                                        <p className="swatch-heading">
                                            Prints + Colors:
                                        </p>
                                        <ul className="swatch-list nostyle">
                                            {patterns
                                                ? patterns.map((p) => {
                                                      // console.log('p in patterns map', p)
                                                      return (
                                                          <li
                                                              key={
                                                                  product.id +
                                                                  ' ' +
                                                                  p
                                                              }
                                                              className={`swatch ${
                                                                  p ===
                                                                  currentPattern
                                                                      ? 'selected-swatch'
                                                                      : ''
                                                              }`}
                                                          >
                                                              <div
                                                                  className="swatch-image"
                                                                  data-product-id={
                                                                      v.id
                                                                  }
                                                                  data-pattern={
                                                                      p
                                                                          ? slugify(
                                                                                p
                                                                            )
                                                                          : null
                                                                  }
                                                                  aria-label={p}
                                                                  data-balloon-pos="up"
                                                                  onClick={() =>
                                                                      handleSwatchClick(
                                                                          product.id,
                                                                          p
                                                                      )
                                                                  }
                                                              >
                                                                  <img
                                                                      src={`${FILES_URL}maswatch-${
                                                                          p
                                                                              ? slugify(
                                                                                    p
                                                                                )
                                                                              : 'default'
                                                                      }-96.png`}
                                                                      alt={`${
                                                                          p
                                                                              ? p
                                                                              : 'default'
                                                                      } swatch`}
                                                                      onError={(
                                                                          e
                                                                      ) => {
                                                                          if (
                                                                              e
                                                                                  .target
                                                                                  .src !==
                                                                              DEFAULT_SWATCH_IMAGE_SRC
                                                                          ) {
                                                                              e.target.onerror =
                                                                                  null
                                                                              e.target.src =
                                                                                  DEFAULT_SWATCH_IMAGE_SRC
                                                                          }
                                                                      }}
                                                                  />
                                                              </div>
                                                          </li>
                                                      )
                                                  })
                                                : null}
                                        </ul>
                                    </div>
                                    <div
                                        className={`product-actions ${
                                            (sizes && sizes.length < 2) ||
                                            !sizes
                                                ? 'no-sizes'
                                                : null
                                        }`}
                                    >
                                        <div className="product-sizes">
                                            <select
                                                className={`product-size-select select-css`}
                                                onChange={handleSizeSelect}
                                                value={value}
                                                data-value={value}
                                                data-variant-id={
                                                    currentVariantId
                                                }
                                            >
                                                <option
                                                    key="null-size-option"
                                                    className="default-option"
                                                    data-variant-id={null}
                                                >
                                                    Size
                                                </option>
                                                {sizes && sizes.length > 0
                                                    ? sizes.map((s) => {
                                                          if (s) {
                                                              return (
                                                                  <option
                                                                      key={s.id}
                                                                      data-variant-id={
                                                                          s.id
                                                                      }
                                                                      value={
                                                                          s.size
                                                                      }
                                                                      data-inventory={
                                                                          s.quantity
                                                                      }
                                                                      className={
                                                                          s.quantity >
                                                                          0
                                                                              ? 'available'
                                                                              : 'disabled'
                                                                      }
                                                                      disabled={
                                                                          s.quantity >
                                                                          0
                                                                              ? false
                                                                              : true
                                                                      }
                                                                  >
                                                                      {s.size}
                                                                  </option>
                                                              )
                                                          }
                                                          return false
                                                      })
                                                    : null}
                                            </select>
                                        </div>

                                        <div className="product-add-to-cart">
                                            <form
                                                action="/cart/add"
                                                acceptCharset="UTF-8"
                                                encType="multipart/form-data"
                                                className="product-atc"
                                            >
                                                <input
                                                    type="hidden"
                                                    min="1"
                                                    name="quantity"
                                                    value="1"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="id"
                                                    value={currentVariantId}
                                                />
                                                {sizes && sizes.length > 2 ? (
                                                    <button
                                                        type="submit"
                                                        className={`large-button button-atc ${
                                                            value &&
                                                            value === 'Size'
                                                                ? 'disabled'
                                                                : null
                                                        }`}
                                                        // disabled={
                                                        //     value &&
                                                        //     value === 'Size'
                                                        //         ? true
                                                        //         : false
                                                        // }
                                                        data-variant-id={
                                                            currentVariantId
                                                        }
                                                        data-balloon-blunt
                                                        data-balloon-pos="up"
                                                        aria-label={
                                                            value &&
                                                            value === 'Size'
                                                                ? 'Please select a size'
                                                                : null
                                                        }
                                                    >
                                                        Add To Cart
                                                    </button>
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className={`large-button button-atc button-no-sizes`}
                                                        data-variant-id={
                                                            currentVariantId
                                                        }
                                                    >
                                                        Add To Cart
                                                    </button>
                                                )}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            ) : null}
        </Fragment>
    )
}

export default Product
